<template>
  <footer class="bg-white text-center py-4" :style="{ width: footerWidth }">
    <p class="text-sm">&copy; {{ currentYear() }} All rights reserved.</p>
    <p class="text-sm">Developed by <a target="_blank"
        href="https://github.com/KrystalBD"
        class="text-blue-400 hover:underline">Krystal Software Bangladesh</a></p>
  </footer>
</template>

<script>
import { currentYear } from '@/helpers/date';

export default {
  name: 'FooterComponent',
  data() {
    return {
      sidebarWidth: '0px',
    };
  },
  computed: {
    footerWidth() {
      return `calc(100% - ${this.sidebarWidth})`;  // Ensures the footer width doesn't overlap the sidebar
    }
  },
  methods: {
    currentYear
  }
}
</script>

<style scoped>
@media (max-width: 767px) {
  footer {
    padding-left: 0 !important;
    margin-left: 0 !important;
    width: 100% !important;
  }
  footer div {
    width: 100%;
  }
}
</style>
